import React, {useState, useMemo, useCallback, useEffect, useRef} from "react";
import "./styles.scss";

import axios from 'util/axios';

import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link } from 'react-router-dom'
import Pagination from 'util/component/Pagination'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faThumbtack } from "@fortawesome/free-solid-svg-icons"

const PAGE_VIEW = 10;


const App = () => {
	const [NoticeData, SetNoticeData] = useState([]);
	const [ NoticePage, SetNoticePage] = useState(1);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const GoDetail = (id) => {
		navigate("/admin/write/"+id)
	}
	const renderNoticeData = useMemo(() => {
		return <>
			<tbody>
				{
					NoticeData.result?.length > 0 ?
						NoticeData.result?.map((v, i) => <tr key={"admin_notice" + i}>
							<td>{i + 1}</td>
							<td className={"notice_title pointer"} onClick={() => {GoDetail(v.noticeId)}}>
								{v.noticeTitle} {v.fixYn > 0 && <FontAwesomeIcon icon={faThumbtack} />}
							</td>
							<td>{v.userNm}</td>
							<td>
								<div className={"flexDiv"}>
									<div>{v.startDt}</div>
									<div className={"seperator"}>~</div>
									<div>{v.endDt ?? ""}</div>
								</div>
							</td>
							<td>{v.createDt}</td>
						</tr>)
						:
						<tr>
							<td colSpan="5" ></td>
						</tr>
				}
			</tbody>
			<tfoot>
				<tr>
					<td colSpan="5">
						<div style={{display: "flex", justifyContent: "space-between"}}>
						<div className="new_btn">
							<Link to="/admin/write">
								Write
							</Link>
						</div>
						<Pagination data={NoticeData.boardPager} onClick={(i) => SetNoticePage(i)} style={{marginTop: "5px"}} />
						</div>
					</td>
				</tr>
			</tfoot>
		</>
	}, [NoticeData])

	const getNoticeData = useCallback(async () => {
		dispatch({type: "LOADING_ON"});
		try {
			const response = await axios.post(process.env.REACT_APP_API + "/notice/retrieveNoticeList", {curPage: NoticePage, boardView: PAGE_VIEW})
				.then(Response => Response.data.data);
			SetNoticeData(response);
		} catch (e) { }
		finally {
			dispatch({type: "LOADING_OFF"})
		}
	}, [SetNoticeData, NoticePage])

	useEffect(() => {
		getNoticeData();
	}, [getNoticeData])


	const [inputVisible, setInputVisible] = useState(false);
    const [date, setDate] = useState("");
    const timeRef = useRef(null)



		const resources = async () => {
		const response = await axios.post(process.env.REACT_APP_API+"/common/resources")
						.then(Response => Response.data.data);
		console.log(response);
	}

  const handleMouseDown = () => {
        // timeRef.current =
        setTimeout(() => {
                setInputVisible(true)
            }, 3000
        )
    }

  const handleKeyPress = async (e) => {
        if (e.key === 'Enter') {
                const response = await axios.post(process.env.REACT_APP_API + "/common/logCheck" ,{"date" : date})
					.then(Response => Response);
                console.log(response);
            }
        }



	return (
		<div className="bpl-container">
			<section className={"admin_notice"}>
				<div className="top">
					<h3 className="list_name">Notice</h3>
					{/* <ul className="search">
						<li className="ss title">Search</li>

						<li className="ss search_menu">
							<select>
								<option value="title">Title</option>
								<option value="content">Contents</option>
								
							</select>
						</li>

						<li className="ss search_box">
							<form action="#" method="post">
								<input type="text" name="search" placeholder="" />
							</form>
						</li>

						<li className="ss search_btn">Search</li>
					</ul> */}
				</div>

				<div className="bottom">
					<table>
						<colgroup>
							<col width="50px"></col>
							<col></col>
							<col width="10%"></col>
							<col width="15%"></col>
							<col></col>
						</colgroup>
						<thead>
						<tr>
							<th>No</th>
							<th style={{textAlign: "left", paddingLeft: "15px"}}>Title</th>
							<th>Owner</th>
							<th>Notice Date</th>
							<th>Create Date</th>
						</tr>
						</thead>
						{renderNoticeData}
					</table>
				</div>
			</section>

		</div>
	)
}

export default App;